import React from 'react';

import { Tooltip } from '@mui/material';

import classes from './HeatmapCell.module.scss';
import { getCellColor } from './utils/getCellColor';

type HeatmapCellProps = {
  count: number;
  maxCount: number;
};

const CELL_HEIGHT = 24;

const HeatmapCell = ({ count, maxCount }: HeatmapCellProps) => {
  const color = getCellColor(count, maxCount);

  return (
    <Tooltip
      title={`Number of scans: ${count}`}
      placement="top"
      slotProps={{
        tooltip: { className: classes.tooltip }, // fix background color for arrow
        popper: {
          modifiers: [{ name: 'offset', options: { offset: [0, -(CELL_HEIGHT / 2)] } }], // fix position of tooltip
        },
      }}
      arrow
    >
      <div className={classes.cell} style={{ backgroundColor: color }} />
    </Tooltip>
  );
};

export { HeatmapCell };
